// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-grid .edit-catagory-heading {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
}
.sub-grid .edit-catagory-sub-heading {
  font-family: "Karla";
  font-weight: 400;
  font-size: 18px;
  line-height: 21.04px;
}

.edit-catagory-modal-items {
  color: #000000 !important;
  font-family: "Karla" !important;
  font-size: 18px !important;
  line-height: 21.04px !important;
  margin-top: 4px !important;
}

.edit-catagory-modal-items-margin-left {
  margin-left: 8px !important;
}

.edit-catagory-input-text {
  font-family: "Karla";
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  height: 45px;
  text-align: center;
  outline: none
}

/* Style for the scrollbar container */
.scrollable-grid::-webkit-scrollbar {
  width: 8px; /* Width of the vertical scrollbar */
  height: 8px; /* Height of the horizontal scrollbar */
}

/* Style for the scrollbar track */
.scrollable-grid::-webkit-scrollbar-track {
  background: #f0f0f0; /* Color of the track */
  border-radius: 8px; /* Rounded corners */
}

/* Style for the scrollbar thumb */
.scrollable-grid::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* Color of the scrollbar thumb */
  border-radius: 8px; /* Rounded corners */
}

/* Style for the scrollbar thumb on hover */
.scrollable-grid::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0; /* Color of the scrollbar thumb on hover */
}

`, "",{"version":3,"sources":["webpack://./src/components/ui/EditCatagoryModal/editCatagory.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA,sCAAsC;AACtC;EACE,UAAU,EAAE,oCAAoC;EAChD,WAAW,EAAE,uCAAuC;AACtD;;AAEA,kCAAkC;AAClC;EACE,mBAAmB,EAAE,uBAAuB;EAC5C,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA,kCAAkC;AAClC;EACE,mBAAmB,EAAE,iCAAiC;EACtD,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB,EAAE,0CAA0C;AACjE","sourcesContent":[".main-grid .edit-catagory-heading {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 36px;\n}\n.sub-grid .edit-catagory-sub-heading {\n  font-family: \"Karla\";\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21.04px;\n}\n\n.edit-catagory-modal-items {\n  color: #000000 !important;\n  font-family: \"Karla\" !important;\n  font-size: 18px !important;\n  line-height: 21.04px !important;\n  margin-top: 4px !important;\n}\n\n.edit-catagory-modal-items-margin-left {\n  margin-left: 8px !important;\n}\n\n.edit-catagory-input-text {\n  font-family: \"Karla\";\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 27px;\n  height: 45px;\n  text-align: center;\n  outline: none\n}\n\n/* Style for the scrollbar container */\n.scrollable-grid::-webkit-scrollbar {\n  width: 8px; /* Width of the vertical scrollbar */\n  height: 8px; /* Height of the horizontal scrollbar */\n}\n\n/* Style for the scrollbar track */\n.scrollable-grid::-webkit-scrollbar-track {\n  background: #f0f0f0; /* Color of the track */\n  border-radius: 8px; /* Rounded corners */\n}\n\n/* Style for the scrollbar thumb */\n.scrollable-grid::-webkit-scrollbar-thumb {\n  background: #c0c0c0; /* Color of the scrollbar thumb */\n  border-radius: 8px; /* Rounded corners */\n}\n\n/* Style for the scrollbar thumb on hover */\n.scrollable-grid::-webkit-scrollbar-thumb:hover {\n  background: #a0a0a0; /* Color of the scrollbar thumb on hover */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
